import React, { Component, Fragment } from 'react';

import Select from 'react-select';
import Dialog from '../../commonModules/interface/Dialog';
import { TableRow, TableCell, Grid, Box, Button, TableHead, TableBody ,TextField, Table} from '@material-ui/core';
import CardPage, { MiniCard } from '../../commonModules/layouts/CardPage';
import InputText, { InputSelect } from '../../commonModules/interface/form-input-inline';
import { TableLayout } from './Stock/containers/Layout';
import DatePicker, { DateTimePicker } from '../../commonModules/MUI/DatePicker';
import { Alert, AlertTitle } from '@material-ui/lab';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';

var Moment = require('moment'),
    $ = require('jquery');

const translatePayTypes = {
    "clasic": "Paiement",
    "gift": "Code gratuit" ,
    "reduction": "Reduction sans activation" ,
    "reductionWithActivation": "Reduction avec activation" ,
    "paymentwithnobox": "Paiement" ,
}
        

class Payment extends Component{
    tabledata = [{id: ''}];
    state ={
        //Initiate Default User
        selectedBox: "",
        selectedBoxDisplay: {value: "", label: ""},
        selectedUser: "",
        selectedUserDisplay: {value: "", label: ""},
        userList: this.tabledata,
        boxList: this.tabledata,
        synchronisationMsgInfo: "",
        upgradeBackMsgInfo: "",
        idBox: "",
        currencyCSS: "fg-line",
        recapPayment: "",
        TimePayment: Moment(Date.now()).format('YYYY-MM-DDTHH:mm'),
        Currency: "", //FCFA",
        ValuePayment: "",
        typePayment: "clasic",
        Info: "",
        popupState: false,
        popupStateValidation: false,
        Ref: "",
        DirectPayment: "yes",
        ModePayment: "mm",
        chkboxDirectAction1: "checked",
        chkboxDirectAction2: "",
        chkboxMode1: "checked",
        chkboxMode2: "",
        error: false,
        errorMsg: "",
        paygoPaymentList: this.tabledata,
        alreadyClick: "Yes",
        checkedCode: "",
        PaymentClass: true,
        PaymentClass2: true,
        Activation: true,
        validButton: false,
        gift: false,
        ValueDayGift: "",
        GiftStatus: "",
        validationCode: "",
        creditAvailable: "",
        otherInfo: {},
        paymentType: false,
        options: [
            {
                id: "",
                boxAssoId: ""
            }
        ],
        optionsUser: [
            {
                boxAssoId: "",
                userId: "",
                userName: "",
                boxID: ""
            }
        ]
    }

    componentDidMount = async () => {
        //Get Data From paygo User
        var methodName = 'paygoUser class';
        var url = "/box/list?status=linked";
        var testTime = Moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        console.log('[DEBUG], ', methodName, ',URL :, ', url, ' & ', testTime);

        this.serverRequest = $.get(url, function (result) {
            console.log('[INFO],  reception des données  des utilisateur de PAYGO ');
            console.log(result);
            var paygoUserTmp = [];
            var optionTmp = [];
            var boxId = '';
            optionTmp.push({id: "", boxAssoId:""})

            try {
                var data = result; //var data = JSON.parse(result);
                for (var i = 0; i < data.content.length; i += 1) {
                    optionTmp.push({id: data.content[i].idBox,boxAssoId:data.content[i].boxAssoId})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }

            console.log(paygoUserTmp);
            this.setState({boxList: paygoUserTmp, options: optionTmp, selectedBox: ""});
        }.bind(this));

        //Get User For Paiement
        var url2 = "/payment/user/list?status=useronly";
        console.log('[DEBUG], ', methodName, ',URL :, ', url2, ' & ', testTime);

        this.serverRequest = $.get(url2, function (result) {
            console.log('[INFO],  reception des données des clients paygo sans box ');
            console.log(result);
            var paygoUserTmp = [];
            var optionTmp = [];
            optionTmp.push({boxAssoId:"",userId: "",userName: "",boxID:""})

            try {
                var data = result; //var data = JSON.parse(result);
                for (var i = 0; i < data.content.length; i += 1) {
                    optionTmp.push({boxAssoId: data.content[i].boxAssoId, userId: data.content[i].idUser, userName: data.content[i].userName,boxID: data.content[i].boxID})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }

            console.log('[INFO],',methodName,', requete user ,', paygoUserTmp);
            this.setState({userList: this.orderByName(paygoUserTmp), optionsUser: optionTmp, selectedBox: ""});
        }.bind(this));
    }
    onPayment = async (e) => {
        e.preventDefault();
        // Capturer les valeurs de l'état avant toute mise à jour asynchrone
        const currentSelectedBox = this.state.selectedBox;
        const currentSelectedUser = this.state.selectedUser;
        const currentSelectedBoxDisplay = this.state.selectedBoxDisplay;
        const currentSelectedUserDisplay = this.state.selectedUserDisplay;
        const currentValuePayment = this.state.ValuePayment;
        const currentCurrency = this.state.Currency;
        const currentRef = this.state.Ref;
        const currentDirectPayment = this.state.DirectPayment;
        const currentTypePayment = this.state.typePayment;
        const currentValueDayGift = this.state.ValueDayGift;
        const currentTimePayment = this.state.TimePayment;
        
        console.log('Proceed Payment');
        console.log(currentTimePayment);
        var datePay = Moment(currentTimePayment).format('YYYY-MM-DD HH:mm:ss');
        console.log(datePay);
        if (Moment(currentTimePayment) > Moment() || datePay == "Invalid date") {
            this.setState({error: "", errorMsg: "Date is not good"});
            return;
        }
        if(isEmpty(currentSelectedBox) && isEmpty(currentSelectedUser)){
            // this.setState({error: "", errorMsg: "Veuillez selectionner un client"});
            toast.error(  "Veuillez selectionner un client")
            return;
        }
        
        // Vérifier que le montant n'est pas 0 pour les types de paiement qui nécessitent un montant
        if ((currentTypePayment === "clasic" || currentTypePayment === "reduction" || 
             currentTypePayment === "reductionWithActivation" || currentTypePayment === "limitPower" || 
             currentTypePayment === "limitKwhPerDay" || currentTypePayment === "paymentwithnobox")) {
            const amountValue = parseFloat(currentValuePayment);
            if (!currentValuePayment || currentValuePayment === "" || isNaN(amountValue) || amountValue <= 0) {
                toast.error("Le montant doit être supérieur à 0");
                return;
            }
        }
        
        // Vérifier que le nombre de jours n'est pas 0 pour les codes gratuits
        if (currentTypePayment === "gift") {
            const daysValue = parseFloat(currentValueDayGift);
            if (!currentValueDayGift || currentValueDayGift === "" || isNaN(daysValue) || daysValue <= 0) {
                toast.error("Le nombre de jours doit être supérieur à 0");
                return;
            }
        }
        
        //Test if ok
        var msg = "";
        if (currentTypePayment === "clasic") {
            msg = "Paiement pour box n° " + currentSelectedBoxDisplay.label + " de " + currentValuePayment + " " + currentCurrency + " en date du " + datePay + ", ref : " + currentRef + "   avec Paiement direct :" + currentDirectPayment;
        } else if (currentTypePayment === "gift") {
            msg = "Code gratuit pour box n° " + currentSelectedBoxDisplay.label + " de " + currentValueDayGift + " jours en date du " + datePay + "!";
        } else if (currentTypePayment === "reduction") {
            msg = "Reduction sans activation pour box n° " + currentSelectedBoxDisplay.label + " de " + currentValuePayment + " en date du " + datePay + "!";
        } else if (currentTypePayment === "reductionWithActivation") {
            msg = "Reduction avec activation pour box n° " + currentSelectedBoxDisplay.label + " de " + currentValuePayment + " en date du " + datePay + "!";
        } else if (currentTypePayment === "cleartemper") {
            msg = "Supprimer l'alerte pour la box n° " + currentSelectedBoxDisplay.label;
        } else if (currentTypePayment === "clearcredit") {
            msg = "Supprimer les crédits pour la box n° " + currentSelectedBoxDisplay.label;
        } else if (currentTypePayment === "limitPower") {
            msg = "Définir une puissance maximal de "+ currentValuePayment + "W pour la box n° " + currentSelectedBoxDisplay.label;
        }else if (currentTypePayment === "limitKwhPerDay") {
            msg = "Définir une energie par jour maximale de "+ currentValuePayment + "Wh pour la box n° " + currentSelectedBoxDisplay.label;
        } else if (currentTypePayment === "removerestriction"){
            msg = "Supprimer la restriction pour la box n° " + currentSelectedBoxDisplay.label;
        } else if (currentTypePayment === "unlockProduct"){
            msg = "Débloquer totalement un produit pour la box n° " + currentSelectedBoxDisplay.label;
        }else if (currentTypePayment ==="lockProduct"){
            msg = "Bloquer le produit " + currentSelectedBoxDisplay.label;
        }else if (currentTypePayment === "paymentwithnobox"){
            msg = "Paiement pour le client " + currentSelectedUserDisplay.label + " de " + currentValuePayment + " en date du " + datePay + " ref : " + currentRef ;
        }

        //Active Pop up Security
        this.setState({popupState: true, recapPayment: msg});
    }
    onChangeRef= async (e) => {
        e.preventDefault();
        var ref = e.target.value;
        this.setState({Ref: ref});
    }
    onChangeDirectPayment= async (e) => {

        this.setState({DirectPayment: e.value, chkboxDirectAction1: this.state.chkboxDirectAction2, chkboxDirectAction2: this.state.chkboxDirectAction1});
    }
    cancelPayment= async (e) => {
        e.preventDefault();
        this.setState({popupState: false});
    }
    validPayment= async (e) => {
        e.preventDefault();
        // Capturer les valeurs de l'état avant toute mise à jour asynchrone
        const currentValuePayment = this.state.ValuePayment;
        const currentSelectedBox = this.state.selectedBox;
        const currentSelectedUser = this.state.selectedUser;
        const currentCurrency = this.state.Currency;
        const currentRef = this.state.Ref;
        const currentModePayment = this.state.ModePayment;
        const currentDirectPayment = this.state.DirectPayment;
        const currentInfo = this.state.Info;
        const currentTypePayment = this.state.typePayment;
        const currentValueDayGift = this.state.ValueDayGift;
        
        console.log('[DEBUG] validPayment - ValuePayment:', currentValuePayment);
        console.log('[DEBUG] validPayment - Full state:', this.state);
        
        this.setState({validButton:true})
        console.log(this.state.TimePayment);
        var d = new Date();
        var offSet = d.getTimezoneOffset();
        console.log("Offset ", offSet);
        var datePay = Moment(this.state.TimePayment)
            .utcOffset(offSet)
            .format(); //'YYYY-MM-DDTHH:mm:ss.SSSZ');
        console.log(datePay);

        // Vérifier qu'un client est sélectionné
        if(isEmpty(currentSelectedBox) && isEmpty(currentSelectedUser)){
            toast.error("Veuillez selectionner un client");
            this.setState({validButton: false});
            return;
        }

        // Vérifier que ValuePayment n'est pas vide ou égal à 0 pour les types de paiement qui nécessitent un montant
        if (currentTypePayment === "clasic" || currentTypePayment === "reduction" || 
            currentTypePayment === "reductionWithActivation" || currentTypePayment === "limitPower" || 
            currentTypePayment === "limitKwhPerDay" || currentTypePayment === "paymentwithnobox") {
            const amountValue = parseFloat(currentValuePayment);
            if (!currentValuePayment || currentValuePayment === "" || isNaN(amountValue) || amountValue <= 0) {
                toast.error("Le montant doit être supérieur à 0");
                this.setState({validButton: false});
                return;
            }
        }
        
        // Vérifier que le nombre de jours n'est pas 0 pour les codes gratuits
        if (currentTypePayment === "gift") {
            const daysValue = parseFloat(currentValueDayGift);
            if (!currentValueDayGift || currentValueDayGift === "" || isNaN(daysValue) || daysValue <= 0) {
                toast.error("Le nombre de jours doit être supérieur à 0");
                this.setState({validButton: false});
                return;
            }
        }

        // Utiliser les valeurs capturées au début de la fonction pour éviter les problèmes de mise à jour asynchrone
        var urlPayment = "/box/payment/new?boxAssoId=" + currentSelectedBox + "&amount=" + currentValuePayment + "&currency=" + currentCurrency + "&date=" + datePay + "&ref=" + currentRef + "&mode=" + currentModePayment + "&activation=" + currentDirectPayment + "&info=" + currentInfo + "&typePay=" + currentTypePayment;
        if (currentTypePayment === "gift") {
            urlPayment = "/code/request/gift?boxAssoId=" + currentSelectedBox + "&nbday=" + currentValueDayGift + "&date=" + datePay + "&activation=" + currentDirectPayment + "&info=" + currentInfo + "&mode=day";
        }else if (currentTypePayment === "paymentwithnobox"){
            urlPayment = "/box/payment/new?boxAssoId=" + currentSelectedUser + "&amount=" + currentValuePayment + "&currency=" + currentCurrency + "&date=" + datePay + "&ref=" + currentRef + "&mode=" + currentModePayment + "&activation=nothanks&info=" + currentInfo + "&typePay=" + currentTypePayment;
        }

        this.serverRequest = $.get(urlPayment, function (result) {
            console.log('[INFO],  reception front des paiements: ');
            console.log(result);
            if (result.error === 'OK') {
                console.log('Code received ', result.content)
                // Capturer la box sélectionnée avant la mise à jour de l'état (utiliser les valeurs capturées)
                const boxAssoIdToRefresh = currentSelectedBox || currentSelectedUser;
                
                this.setState({
                    popupState: false,
                    // Ne pas réinitialiser selectedBox et selectedBoxDisplay pour permettre d'entrer un autre paiement
                    // selectedBox: "",
                    // selectedBoxDisplay: {value: "", label: ""},
                    ValuePayment: "",
                    TimePayment: Moment(Date.now()).format('YYYY-MM-DDTHH:mm'),
                    Info: "",
                    Ref: "",
                    ValueDayGift: "",
                    validationCode: result.content,
                    popupStateValidation: true,
                    typePayment: "clasic",
                    validButton:false,
                });
                
                // Recharger la liste des paiements pour afficher le nouveau paiement
                // Utiliser les valeurs capturées car elles sont dans la portée de la fonction
                if (boxAssoIdToRefresh) {
                    var methodName = 'refreshPaymentList after payment';
                    var url = "/box/payment/getlist?boxAssoId=" + boxAssoIdToRefresh;
                    
                    // Utiliser une variable différente pour éviter d'écraser la requête principale
                    var refreshRequest = $.get(url, function (result) {
                        console.log('[INFO],  refresh liste des paiements après paiement');
                        var paymentTmp = [];
                        
                        try {
                            var data = result;
                            for (var i = 0; i < data.content.length; i += 1) {
                                var d = Date.parse(data.content[i].timePayment);
                                var dnow = new Date();
                                var offSet = dnow.getTimezoneOffset();
                                var dtz = new Date(d - 1000 * 60 * offSet);
                                
                                paymentTmp.push({
                                    id: data.content[i].id,
                                    timePayment: dtz.toISOString(),
                                    money: data.content[i].money,
                                    typePayment: data.content[i].typePayment,
                                    codeId: data.content[i].codeId,
                                    info: data.content[i].info
                                })
                            }
                        } catch (e) {
                            console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                            console.log(e);
                        }
                        
                        this.setState({paygoPaymentList: paymentTmp});
                    }.bind(this));
                }
            } else {
                this.setState({recapPayment: 'Erreur paiement '+result.error,
                validButton:false,});
            }
        }.bind(this));
    }
    validFinalPayment= async (e) => {
        e.preventDefault();
        this.setState({popupStateValidation: false, validationCode: "", paygoPaymentList: []});
    }
    onChangePayment= async (e) => {
        var amount = e.target.value;
        console.log("Montant => ", amount)
        this.setState({ValuePayment: amount});
    }
    onChangeModePayment= async (e) => {
        //e.preventDefault();
        console.log("Mode Paiement :", e);
        var mode = e.value;
        var mode1 = 'checked';
        var mode2 = '';
        console.log("Mode Paiement :", mode);
        if (mode === 'mtn') {
            console.log("Mode Paiement Checked:", mode);
            mode1 = false;
            mode2 = true;
        }
        this.setState({ModePayment: mode, chkboxMode2: mode2, chkboxMode1: mode1});
    }
    onChangeInfo= async (e) => {
        e.preventDefault();
        var info = e.target.value;
        this.setState({Info: info});
    }
    onChangeTimePayment = (info) => {
        console.log("onChangeTimePayment >> ",info)
        console.log("onChangeTimePayment >> ",info.target)
        this.setState({TimePayment: info.target.value});
    }
    handleSelect = async (option) => {
        // e.preventDefault();
        console.log("[INFO], handleSelect, ",option)
        var info = option.value;
        if (this.state.typePayment === "paymentwithnobox"){
            this.setState({selectedUser: info, selectedUserDisplay: option});
        } else {
            this.setState({selectedBox: info, selectedBoxDisplay: option});
        }

        if (this.state.TimePayment === "") {
            this.setState({
                TimePayment: Date.now()
            })
        }
        var methodName = 'getLastPayment class';
        var url = "/box/payment/getlist?boxAssoId=" + info;

        this.serverRequest = $.get(url, function (result) {
            console.log('[INFO],  reception des données  du PAYGO ');
            console.log(result);
            var paygoUserTmp = [];
            var paymentTmp = [];
            var boxId = '';

            try {
                var data = result;

                for (var i = 0; i < data.content.length; i += 1) {

                    var d = Date.parse(data.content[i].timePayment);

                    var dnow = new Date();
                    var offSet = dnow.getTimezoneOffset();
                    var dtz = new Date(d - 1000 * 60 * offSet);

                    paymentTmp.push({
                        id: data.content[i].id,
                        timePayment: dtz.toISOString(),
                        money: data.content[i].money,
                        typePayment: data.content[i].typePayment,
                        codeId: data.content[i].codeId,
                        info: data.content[i].info
                    })
                }
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
            }

            this.setState({paygoPaymentList: paymentTmp});
        }.bind(this));

        //Get Credit Still Available for this sensor
        var urlExtraBoxInfo = "/box/payment/getExtraInfo?boxAssoId=" + info;
        
        this.serverRequestExtra = $.get(urlExtraBoxInfo, function (result) {
            console.log('[INFO],  reception des données  du PAYGO ');
            console.log(result);
            let creditAvailable = '';
            let otherInfo={};

            try {
                let data = result;
                creditAvailable = data.content.credit;
                otherInfo = data.content;
                if (typeof creditAvailable === 'undefined'){
                    creditAvailable='';
                }
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
            }

            this.setState({creditAvailable: creditAvailable,otherInfo: otherInfo});
        }.bind(this));
        
    }

    orderByName= (e) => {
        //Order By User Name
        var sortable = e;

        sortable.sort(function(a, b) {
            return a.userName - b.userName;
        });
        return sortable
    }
    componentWillUnmount () {
        try {
            this
                .serverRequest
                .abort();
            
        } catch (e) {
            console.log(e);
        }
    }
   
    onClickTypePayment= async (e) => {
        //e.preventDefault();
        console.log('[INFO], Click on change type payment',e);

        var info = e.value;
        this.setState({typePayment: info});

        //Case it is a gift
        var pay = false;
        var pay2 = false;
        var gift = true;
        var GiftStatus = false;
        var Activation = true;

        if (info === "clasic"){
            pay = true;
            pay2 = true;
            gift = false;
            GiftStatus = "";
        } else if (info === "reductionWithActivation"){
            pay = true;
            gift = false;
            GiftStatus = false;
        } else if (info === "reduction"){
            pay = true;
            pay2 = false;
            gift = false;
            GiftStatus = false;
            Activation = false;
        } else if (info === "cleartemper"){
            pay = false;
            pay2 = false;
            gift = false;
            GiftStatus = false;
            Activation = false;
        } else if (info === "clearcredit"){
            pay = false;
            pay2 = false;
            gift = false;
            GiftStatus = false;
            Activation = false;
        } else if (info === "limitPower"){
            pay = true;
            pay2 = false;
            gift = false;
            GiftStatus = false;
            Activation = false;
        } else if (info === "limitKwhPerDay"){
            pay = true;
            pay2 = false;
            gift = false;
            GiftStatus = false;
            Activation = false;
        } else if (info === "removerestriction"){
            pay = false;
            pay2 = false;
            gift = false;
            GiftStatus = false;
            Activation = false;
        } else if (info === "unlockProduct"){
            pay = false;
            pay2 = false;
            gift = false;
            GiftStatus = false;
            Activation = false;
        }else if (info === "lockProduct"){
            pay = false;
            pay2 = false;
            gift = false;
            GiftStatus = false;
            Activation = false;
        }else if (info === "paymentwithnobox"){
            pay = true;
            pay2 = true;
            gift = false;
            GiftStatus = true;
            Activation = false;
        }
        this.setState({selectedUser: "",creditAvailable: "", checkedCode: "checked", Activation:Activation, PaymentClass2: pay2, PaymentClass: pay, gift: gift, GiftStatus: GiftStatus});
    }
    render () {
        const {options, optionsUser, paygoPaymentList} = this.state;
        console.log('==================STATE==================');
        console.log(this.state);
        console.log('====================================');
        // TO DO
        var listBox = options;
        listBox.sort(function (a, b) {
            if (a.id > b.id) {
                return -1;
            }
            if (a.id < b.id) {
                return 1;
            }
            return 0;
        });
        var listUser = optionsUser;
        listUser.sort(function (a, b) {
            if (a.userName > b.userName) {
                return -1;
            }
            if (a.userName < b.userName) {
                return 1;
            }
            return 0;
        });
        var rowsPaygoPayment = [];
        console.log(paygoPaymentList);

        paygoPaymentList.sort(function (a, b) {
            a = new Date(a.timePayment);
            b = new Date(b.timePayment);
            if (a > b) {
                return -1;
            }
            if (a < b) {
                return 1;
            }
            return 0;
        });
        rowsPaygoPayment = paygoPaymentList.map(paymentInfo => (
            <TableRow className={paymentInfo.classN} key={paymentInfo.timePayment}>
                <TableCell>{paymentInfo.timePayment}</TableCell>
                <TableCell>{paymentInfo.money}</TableCell>
                <TableCell>{paymentInfo.typePayment}</TableCell>
                <TableCell>{paymentInfo.codeId}</TableCell>
                <TableCell>{paymentInfo.id}</TableCell>
                <TableCell>{paymentInfo.info}</TableCell>
            </TableRow>
        ))
        // this.state.paygoPaymentList.forEach(function (paymentInfo) {
        //     rowsPaygoPayment.push(
        //         <TableRow className={paymentInfo.classN} key={paymentInfo.timePayment}>
        //             <TableCell>{paymentInfo.timePayment}</TableCell>
        //             <TableCell>{paymentInfo.money}</TableCell>
        //             <TableCell>{paymentInfo.typePayment}</TableCell>
        //             <TableCell>{paymentInfo.codeId}</TableCell>
        //             <TableCell>{paymentInfo.id}</TableCell>
        //             <TableCell>{paymentInfo.info}</TableCell>
        //         </TableRow>
        //     );
        // }.bind(this));
        return (
            <CardPage title="Enregistrer un nouveau paiement" subtitle="Nouveau Paiement">
                 {this.state.popupState &&
                    <Dialog 
                        title={translatePayTypes[this.state.typePayment]}
                        block={true}
                        submitAction={this.validPayment}
                        disabledSubmit={this.state.validButton}
                        close={this.cancelPayment}
                    >
                        <p>{this.state.recapPayment}</p>

                        {/* <Table>
                            <TableBody>
                                {this.state.typePayment === "paymentwithnobox" ?
                                <TableRow>
                                    <TableCell component="th">Client</TableCell>
                                    <TableCell>{this.state.selectedUserDisplay.label}</TableCell>
                                </TableRow>
                                :
                                <TableRow>
                                    <TableCell component="th">Box n°</TableCell>
                                    <TableCell>{this.state.selectedBoxDisplay.label}</TableCell>
                                </TableRow>
                                }
                                <TableRow>
                                    <TableCell component="th">Montant</TableCell>
                                    <TableCell>{this.state.typePayment === "gift" ? `${this.state.ValueDayGift} jours` : this.state.ValuePayment}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th">Date de Paiement</TableCell>
                                    <TableCell>{Moment(this.state.TimePayment).format('DD/MM/YYYY HH:mm')}</TableCell>
                                </TableRow>
                                {(this.state.typePayment === "clasic" || this.state.typePayment === "paymentwithnobox" ) &&
                                    <TableRow>
                                        <TableCell component="th">Référence</TableCell>
                                        <TableCell>{this.state.Ref}</TableCell>
                                    </TableRow>
                                }
                                {this.state.typePayment === "clasic" &&
                                    <TableRow>
                                        <TableCell component="th">Paiement Direct</TableCell>
                                        <TableCell>{this.state.DirectPayment}</TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table> */}

                    </Dialog>
                }
                {this.state.popupStateValidation &&
                    <Dialog 
                        title={"Retour Paiement"}
                        block={true}
                        submitAction={this.validFinalPayment}
                        disabledSubmit={this.state.validButton}
                        close={() => this.setState({ popupStateValidation : false})}
                    >
                        <p>Code : {this.state.validationCode}</p>
                    </Dialog>
                }

                <Grid container>
                    <Grid item xs={12} md={6} container>
                        <Grid item xs={12}>
                            <InputSelect
                                label="Type de paiement"
                                value={this.state.typePayment}
                                onChange={(value) =>  this.onClickTypePayment(value)}
                                options={[
                                    { value:"clasic", label:"Normal"},
                                    { value:"gift", label:"Code Gratuit"},
                                    { value:"reduction", label:"Réduction sans activation"},
                                    { value:"reductionWithActivation", label:"Réduction avec activation"},
                                    { value:"paymentwithnobox", label:"Paiement sans box"},
                                    { value:"cleartemper", label:"Retirer Alerte"},
                                    { value:"clearcredit", label:"Mise à zéro du crédit"},
                                    { value:"limitPower", label:"Limitation Puissance"},
                                    { value:"limitKwhPerDay", label:"Limitation Energie Jour"},
                                    { value:"removerestriction", label:"Retirer Restriction"},
                                    { value:"lockProduct", label:"Bloquer Produit"},
                                    { value:"unlockProduct", label:"Debloquer Produit"},
                                ]}
                            />
                        </Grid>
                        { this.state.creditAvailable !== ""  &&
                            <Grid item xs={12}>
                                <Alert severity="info">  
                                    <AlertTitle>Nom Client: {this.state.otherInfo.clientName} - Nom contrat: {this.state.otherInfo.contractName}</AlertTitle>
                                    Payé {this.state.otherInfo.amountPayed} sur {this.state.otherInfo.amountToPay} prochain paiement doit être de {this.state.otherInfo.nextPayment} Crédit restant: {this.state.creditAvailable}
                                </Alert>
                            </Grid>
                        }
                        {this.state.typePayment !== "paymentwithnobox" &&
                        <Grid item xs={12}>
                            <InputSelect
                                label="Choisissez une Box"
                                value={this.state.selectedBox}
                                onChange={(value) => this.handleSelect(value)}
                                options={listBox.map( optionval => (
                                    { value: optionval.boxAssoId, label:optionval.id }
                                ))}
                            />
                        </Grid>
                        }

                        {this.state.typePayment === "paymentwithnobox" &&
                        <Grid item xs={12}>
                            <InputSelect
                                    // labelWidth={150}
                                    label="Choisissez un client"
                                    value={this.state.selectedUser}
                                    onChange={(value) => this.handleSelect(value)}
                                    options={listUser.map( optionval => (
                                        { value: optionval.boxAssoId, label:optionval.userName+ " - "+optionval.boxID }
                                    ))}
                                />
                        </Grid>
                        }
                        {this.state.gift &&
                            <Grid item xs={12}>
                                <InputText
                                    type="number"
                                    value={this.state.ValueDayGift}
                                    onChange={(e) => {
                                        this.setState({ValueDayGift: e.target.value})
                                    }}
                                    label="Nombre de jour"
                                />
                            </Grid>
                        }
                        {this.state.PaymentClass &&
                            <Grid item xs={12}>
                                <InputText
                                    type="number"
                                    value={this.state.ValuePayment}
                                    onChange={this.onChangePayment}
                                    label="Montant"
                                />
                            </Grid>
                        }
                            
                        {this.state.PaymentClass2 &&
                        <Fragment>
                            <Grid item xs={12}>
                                <InputText
                                    // id="datetime-local"
                                    label="Date Paiement"
                                    type="datetime-local"
                                    defaultValue="2017-05-24T10:30"
                                    value={this.state.TimePayment} 
                                    onChange={(value) =>this.onChangeTimePayment(value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                {/* <DateTimePicker
                                    label="Date Paiement"
                                    defaultValue="2017-05-24T10:30"
                                    value={this.state.TimePayment} 
                                    onChange={(value) =>this.onChangeTimePayment(value)}
                                /> */}
                            </Grid>
                            <Grid item xs={12}>
                                <InputSelect
                                    label="Mode de Paiement"
                                    value={this.state.ModePayment}
                                    onChange={(value) => this.onChangeModePayment(value)}
                                    options={[
                                        { value: "mm", label: "Mobile Money"},
                                        { value: "cash", label: "cash"},
                                        { value: "wire", label: "wire transfert"},
                                        { value: "check", label: "check"},
                                        { value: "card", label: "credit card"},
                                        { value: "other", label: "other"}
                                    ]}
                                    // options={[
                                    //     <option key="mm" value="mm">Mobile Money</option>,
                                    //     <option key="cash" value="cash">cash</option>,
                                    //     <option key="wire" value="wire">wire transfert</option>,
                                    //     <option key="check" value="check">check</option>,
                                    //     <option key="card" value="card">credit card</option>,
                                    //     <option key="other" value="other">other</option>
                                    // ]}
                                />
                                
                            </Grid>
                            <Grid item xs={12}>
                                <InputText
                                    type="text"
                                    value={this.state.Ref}
                                    onChange={this.onChangeRef}
                                    label="Référence Paiement"
                                />
                            </Grid>
                        </Fragment>
                        }      
                        {this.state.Activation &&
                            <Grid item xs={12}>
                                <InputSelect
                                    value={this.state.DirectPayment}
                                    onChange={(value) => this.onChangeDirectPayment(value)}
                                    label="Type d'activation"
                                    options={[
                                        {value: "yes", label:"Yes"},
                                        {value: "yesy", label:"Yes, with internet only"},
                                        {value: "no", label:"No, Just Send Code Activation to User"},
                                        {value: "nothanks", label:"No, DO NOT GENERATE A CODE"},
                                    ]}
                                />
                                {/* <p className="c-black f-500 m-b-20">Type d'activation</p>
                                    <div className="fg-line">
                                        <select
                                            className="form-control"
                                            value={this.state.DirectPayment}
                                            onChange={this.onChangeDirectPayment}>
                                            <option key="yes" value="yes">Yes</option>
                                            <option key="yesy" value="yesy">Yes, with internet only</option>
                                            <option key="no" value="no">No, Just Send Code Activation to User</option>
                                            <option key="nothanks" className={this.state.GiftStatus} value="nothanks">No, DO NOT GENERATE A CODE</option>
                                        </select>
                                    </div> */}
                            </Grid>
                        }      

                        <Grid item xs={12}>
                            <InputText
                                type="text"
                                label="Remarques"
                                value={this.state.Info}
                                onChange={this.onChangeInfo}
                                rows={2}
                            />
                            
                        </Grid>
                        {/*Appliquer tarification classique (Yes/no) == If no add a menu*/}
                        
                        {this.state.error &&
                        <Grid item xs={12}>
                            {/* <div className={this.state.error}>
                                {this.state.errorMsg}
                            </div> */}
                            <Alert severity="error">
                                {this.state.errorMsg}
                            </Alert>
                        </Grid>
                        }
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.onPayment}
                            >
                                Entrer Paiement
                            </Button>
                        </Grid>
                        
                    </Grid>

                    <Grid item sm={12} md={6}>
                    {/* <Box p={2}> */}
                        <MiniCard title="Liste des derniers Paiements">
                            <Box p={1}>
                                {this.state.selectedBox && !this.state.typePayment === "paymentwithnobox" && 
                                <small>
                                    Pour la Box n°{this.state.selectedBox}
                                </small>
                                }
                                {this.state.selectedUser && this.state.typePayment === "paymentwithnobox"  && 
                                <small>
                                    Pour l'utilisateur {this.state.selectedUserDisplay.label}
                                </small>
                                }
                            </Box>

                            <TableLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Valeur</TableCell>
                                        <TableCell>Mode Réglement</TableCell>
                                        <TableCell>Déblocage</TableCell>
                                        <TableCell>Ref Paiement</TableCell>
                                        <TableCell>Extra Info</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rowsPaygoPayment}
                                </TableBody>
                            </TableLayout>
                        </MiniCard>
                    {/* </Box> */}
                    </Grid>
                    
                </Grid>
                    
            </CardPage>
        )
    }
};
export default Payment

